import axios from "axios";
import { useEffect, useState } from "react";
import ApiUrl from "../Environment/ApiUrl";
import { useNavigate } from "react-router-dom";
import { useToast } from "../Toast/ToastContext";

function AddLoan({ toggleSidebar }) {
  const navigate = useNavigate();
  const toast = useToast();
  const [showModal, setShowModal] = useState(false);
  const [showCustomerModal, setShowCustomerModal] = useState(false);
  const [generateNumber, setGenerateNumber] = useState("");
  const [customerData, setCustomerData] = useState([]);
  const [productData, setProductData] = useState([]);
  const [actionType, setActionType] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [isManualProductInput, setIsManualProductInput] = useState(false);
  const [code, setCode] = useState(""); // For A-Z dropdown
  const [inputNumber, setInputNumber] = useState(""); // For 1-500 dropdown
  const [amount, setAmount] = useState("");
  const [userdata, setUserdata] = useState([]);
  const [loggedInUser, setLoggedInUser] = useState(null);
  const [selectedManager, setSelectedManager] = useState("");
  const [selectedStaff, setSelectedStaff] = useState("");
  const [staffList, setStaffList] = useState([]);
  const [isManagerLocked, setIsManagerLocked] = useState(false);
  const [isStaffLocked, setIsStaffLocked] = useState(false);
  const [showProductModal, setShowProductModal] = useState(false);
  const [isTranslating, setIsTranslating] = useState(false);
  const [productFormErrors, setProductFormErrors] = useState({});
  const [productAddData, setProductAddData] = useState({
  item_code: "",
  item_name: "",
  item_name_english: "",
  item_name_tamil: "",
  category: "",
  type: "",
  pure_percent: "",
  status: "Active",
  image: null,
});
  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);
  const openCustomerModal = () => {
    setAddCustomerData({
      ...addCustomerData,
      customer_type: addData.customer_type,
    });
    generateCustomerId(addData.customer_type);
    setShowCustomerModal(true);
  };
  const closeCustomerModal = () => {
    setShowCustomerModal(false);
    setActionType("");
    setAddCustomerData({
      customer_type: "",
      customer_id: "",
      name: "",
      mobile: "",
      address: "",
      status: "",
      created_by: "system",
      created_date: "",
      updated_by: "",
      updated_date: "",
    });
    setValidationErrors({});
  };

  const handlePrint = () => {
    navigate(`/loan-bill/${addData.loan_id}`);
  };

  // Add this function after your other functions (around line 200)
const translateToTamil = async (englishText) => {
  if (!englishText || englishText.trim().length < 2) return "";
  
  setIsTranslating(true);
  
  const apis = [
    async () => {
      const encoded = encodeURIComponent(englishText.trim());
      const res = await fetch(`https://api.mymemory.translated.net/get?q=${encoded}&langpair=en|ta`);
      const data = await res.json();
      const translated = data?.responseData?.translatedText;
      if (translated && translated.toLowerCase() !== englishText.toLowerCase()) {
        return translated;
      }
      return null;
    },
    async () => {
      const encoded = encodeURIComponent(englishText.trim());
      const res = await fetch(`https://lingva.ml/api/v1/en/ta/${encoded}`);
      if (res.ok) {
        const data = await res.json();
        if (data.translation && data.translation !== englishText) {
          return data.translation;
        }
      }
      return null;
    },
    async () => {
      const res = await fetch('https://libretranslate.com/translate', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          q: englishText.trim(),
          source: 'en',
          target: 'ta',
          format: 'text'
        })
      });
      if (res.ok) {
        const data = await res.json();
        if (data.translatedText) {
          return data.translatedText;
        }
      }
      return null;
    }
  ];
  
  for (const api of apis) {
    try {
      const result = await api();
      if (result) {
        setIsTranslating(false);
        return result;
      }
    } catch (error) {
      console.warn("Translation API failed:", error);
      continue;
    }
  }
  
  setIsTranslating(false);
  return "";
};

  // Fetch initial data
  useEffect(() => {
    toggleSidebar();
    fetchDataGenerate();
    fetchCustomerData();
    fetchProductData();
    fetchUserData(); // ← NEW
    fetchLoggedInUser();
  }, []);

  // Add these functions (around line 250)
const fetchProductItemCode = async () => {
  try {
    const response = await axios.get(`${ApiUrl}/Api/product.php/generate-item-code`);
    setProductAddData(prev => ({
      ...prev,
      item_code: response.data?.item_code || "",
    }));
  } catch (error) {
    console.error("Error fetching product item code:", error.message);
    toast.error("Failed to generate product code", 3000, "topRight");
  }
};

const openProductModal = () => {
  fetchProductItemCode();
  setProductAddData({
    item_code: "",
    item_name: "",
    item_name_english: "",
    item_name_tamil: "",
    category: "",
    type: "",
    pure_percent: "",
    status: "Active",
    image: null,
  });
  setProductFormErrors({});
  setShowProductModal(true);
};

const closeProductModal = () => {
  setShowProductModal(false);
  setProductAddData({
    item_code: "",
    item_name: "",
    item_name_english: "",
    item_name_tamil: "",
    category: "",
    type: "",
    pure_percent: "",
    status: "Active",
    image: null,
  });
  setProductFormErrors({});
};

// Add this function (around line 300)
const handleProductSubmit = async (e) => {
  e.preventDefault();

  const errors = {};
  if (!productAddData.item_name_english) errors.item_name = "Item name is required";
  if (!productAddData.category) errors.category = "Category is required";
  if (!productAddData.pure_percent) errors.pure_percent = "Purity percentage is required";
  if (!productAddData.status) errors.status = "Status is required";

  if (Object.keys(errors).length > 0) {
    setProductFormErrors(errors);
    return;
  }

  try {
    setLoading(true);
    const formData = new FormData();
    
    // Auto-translate if Tamil name is empty
    let finalTamilName = productAddData.item_name_tamil;
    if (!finalTamilName && productAddData.item_name_english) {
      finalTamilName = await translateToTamil(productAddData.item_name_english);
    }

    formData.append("item_code", productAddData.item_code || "");
    formData.append("item_name", productAddData.item_name_english || "");
    formData.append("item_name_english", productAddData.item_name_english || "");
    formData.append("item_name_tamil", finalTamilName || "");
    formData.append("category", productAddData.category || "");
    formData.append("type", productAddData.type || "");
    formData.append("pure_percent", productAddData.pure_percent || "");
    formData.append("status", productAddData.status || "");
    formData.append("created_by", "system");

    if (productAddData.image) {
      formData.append("image", productAddData.image);
    }

    const response = await axios.post(`${ApiUrl}/Api/product.php`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    if (response.data?.status === true || response.status === 200 || response.status === 201) {
      toast.success("Product added successfully!", 3000, "topRight");
      closeProductModal();
      await fetchProductData(); // Refresh product list
    } else {
      throw new Error(response.data?.message || "Failed to add product");
    }
  } catch (error) {
    console.error("Error adding product:", error);
    toast.error(error.response?.data?.message || "Failed to add product", 3000, "topRight");
  } finally {
    setLoading(false);
  }
};

  const fetchDataGenerate = async () => {
    try {
      const response = await axios.get(
        `${ApiUrl}/Api/loan.php/generate-loan-code`,
      );
      setGenerateNumber(response.data.loan_id || "");
    } catch (error) {
      console.error("Error fetching loan code:", error.message);
      setGenerateNumber("");
      toast.error("Failed to generate loan ID", 3000, "topRight");
    }
  };

  const fetchCustomerData = async () => {
    try {
      const response = await axios.get(`${ApiUrl}/Api/customer.php`);
      const data = response.data?.data || [];
      setCustomerData(data.reverse()); // Reversing to show latest customers first
    } catch (error) {
      console.error("Error fetching customer data:", error.message);
      setCustomerData([]);
      toast.error("Failed to fetch customer data", 3000, "topRight");
    }
  };

  const fetchProductData = async () => {
    try {
      const response = await axios.get(`${ApiUrl}/Api/product.php`);
      setProductData(response.data?.data || []);
    } catch (error) {
      console.error("Error fetching product data:", error.message);
      setProductData([]);
      toast.error("Failed to fetch product data", 3000, "topRight");
    }
  };

  const generateCustomerId = async (customerType) => {
    if (customerType === "Walk-In") {
      setAddCustomerData((prev) => ({
        ...prev,
        customer_id: "TJCWI-001", // Fixed ID for Walk-In as per requirement
      }));
    } else {
      try {
        const response = await axios.get(
          `${ApiUrl}/Api/customer.php/generate-customer-code`,
        );
        setAddCustomerData((prev) => ({
          ...prev,
          customer_id: response.data?.customer_id || "",
        }));
      } catch (error) {
        console.error("Error fetching generated ID:", error.message);
        setAddCustomerData((prev) => ({ ...prev, customer_id: "" }));
        toast.error("Failed to generate customer ID", 3000, "topRight");
      }
    }
  };

  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const [addData, setAddData] = useState({
    loan_id: generateNumber,
    loan_date: getCurrentDate(),
    customer_type: "",
    customer_id: "",
    customer_name: "",
    mobile: "",
    address: "",
    loan_amount: "",
    notes: "",
    loan_list: [],
    created_by: "system",
    created_date: "",
    manager: "",
    manager_name: "",
    staff: "",
  });

  const [addCustomerData, setAddCustomerData] = useState({
    customer_type: "",
    customer_id: "",
    name: "",
    mobile: "",
    address: "",
    status: "",
    created_by: "system",
    created_date: "",
    updated_by: "",
    updated_date: "",
  });

  const [newItem, setNewItem] = useState({
    loan_id: "",
    product_name: "",
    category: "",
    quantity: "1",
    weight: "",
    amount: "",
  });

  useEffect(() => {
    if (code && inputNumber && amount && parseFloat(amount) > 0) {
      const generatedId = `L${code}${inputNumber}-${Math.round(parseFloat(amount))}`;
      setAddData((prev) => ({ ...prev, loan_id: generatedId.toUpperCase() }));
    }
  }, [code, inputNumber, amount]);

  const handleCustomerTypeChange = (e) => {
    const customerType = e.target.value;
    setAddData({
      ...addData,
      customer_type: customerType,
      customer_id: "",
      customer_name: "",
      mobile: "",
      address: "",
    });
    setAddCustomerData({ ...addCustomerData, customer_type: customerType });
    generateCustomerId(customerType);
  };

  const handleCustomerChange = (e) => {
    const selectedCustomerId = e.target.value;
    const selectedCustomer = customerData.find(
      (customer) =>
        `${customer.customer_id}-${customer.id}` === selectedCustomerId,
    );

    if (selectedCustomer) {
      setAddData({
        ...addData,
        customer_id: selectedCustomer.customer_id,
        customer_name: selectedCustomer.name || "",
        mobile: selectedCustomer.mobile || "",
        // address: selectedCustomer.address || "",
      });
    } else {
      setAddData({
        ...addData,
        customer_id: "",
        customer_name: "",
        mobile: "",
        address: "",
      });
    }
  };

  const handleItemInputChange = (e) => {
    const { name, value } = e.target;
    setNewItem({
      ...newItem,
      [name]: value,
    });
  };

  const calculateTotalWorth = (items) => {
    const total = items.reduce((sum, item) => {
      const amount = parseFloat(item.amount) || 0;
      return sum + amount;
    }, 0);
    return total.toFixed(2);
  };

  useEffect(() => {
    const totalWorth = calculateTotalWorth(addData.loan_list);
    setAddData((prevData) => ({
      ...prevData,
      loan_amount: totalWorth,
    }));
  }, [addData.loan_list]);

  const handleAddItem = () => {
    if (!newItem.category) {
      toast.error("Please select a category", 3000, "topRight");
      return;
    }
    if (!newItem.product_name) {
      toast.error("Please enter/select a product name", 3000, "topRight");
      return;
    }
    if (!newItem.quantity || parseFloat(newItem.quantity) <= 0) {
      toast.error("Please enter a valid quantity", 3000, "topRight");
      return;
    }
    if (!newItem.weight || parseFloat(newItem.weight) <= 0) {
      toast.error("Please enter a valid weight", 3000, "topRight");
      return;
    }
    if (!newItem.amount || parseFloat(newItem.amount) <= 0) {
      toast.error("Please enter a valid amount", 3000, "topRight");
      return;
    }

    const itemToAdd = {
      ...newItem,
      id: Date.now().toString(),
      loan_id: generateNumber,
    };

    const updatedItems = [...addData.loan_list, itemToAdd];

    setAddData({
      ...addData,
      loan_list: updatedItems,
    });

    setNewItem({
      loan_id: generateNumber,
      product_name: "",
      category: "",
      quantity: "1",
      weight: "",
      amount: "",
    });

    setIsManualProductInput(false);
  };

  const [editingItemId, setEditingItemId] = useState(null);

  const handleEditItem = (item) => {
    setEditingItemId(item.id);
    setNewItem({
      loan_id: item.loan_id || generateNumber,
      product_name: item.product_name,
      category: item.category,
      quantity: item.quantity,
      weight: item.weight,
      amount: item.amount,
    });
    const isInList = productData.some(
      (product) => product.item_name === item.product_name,
    );
    setIsManualProductInput(!isInList);
  };

  const handleUpdateItem = () => {
    if (editingItemId === null) return;

    const updatedItems = addData.loan_list.map((item) => {
      if (item.id === editingItemId) {
        return {
          ...item,
          loan_id: generateNumber,
          product_name: newItem.product_name,
          category: newItem.category,
          quantity: newItem.quantity,
          weight: newItem.weight,
          amount: newItem.amount,
        };
      }
      return item;
    });

    setAddData({
      ...addData,
      loan_list: updatedItems,
    });

    setEditingItemId(null);
    setNewItem({
      loan_id: generateNumber,
      product_name: "",
      category: "",
      quantity: "1",
      weight: "",
      amount: "",
    });
    setIsManualProductInput(false);
  };

  const handleRemoveItem = (id) => {
    const updatedItems = addData.loan_list.filter((item) => item.id !== id);
    setAddData({
      ...addData,
      loan_list: updatedItems,
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setAddData({
      ...addData,
      [name]: value,
    });
  };
  useEffect(() => {
    const total = calculateTotalWorth(addData.loan_list);
    setAmount(total); // Update amount state for Loan ID
  }, [addData.loan_list]);
const validateCustomerForm = (data) => {
  const errors = {};
  if (!data.customer_type) errors.customer_type = "Customer type is required";
  
  const role = JSON.parse(localStorage.getItem("user") || "{}").role || "";
  const isAdmin = role === "Admin" || role === "admin";
  
  if (!selectedManager) {
    toast.error("Please select a Manager", 3000, "topRight");
    return false;
  }
  if (!isAdmin && !selectedStaff) {
    toast.error("Please select a Staff", 3000, "topRight");
    return false;
  }
  if (!data.name) errors.name = "Name is required";
  if (!data.mobile || !/^\d{10}$/.test(data.mobile))
    errors.mobile = "Valid 10-digit mobile number is required";
  if (!data.status) errors.status = "Status is required";
  setValidationErrors(errors);
  return Object.keys(errors).length === 0;
};

  // const handleCustomerSubmit = async (e) => {
  //   e.preventDefault();
  //   if (!validateCustomerForm(addCustomerData)) return;

  //   try {
  //     setLoading(true);
  //     const formData = {
  //       ...addCustomerData,
  //       created_date: new Date().toISOString().slice(0, 19).replace("T", " "),
  //       updated_date: new Date().toISOString().slice(0, 19).replace("T", " "),
  //     };

  //     await axios.post(`${ApiUrl}/Api/customer.php`, formData);
  //     toast.success("Customer added successfully!", 3000, "topRight");
  //     await fetchCustomerData();
  //     setAddData({
  //       ...addData,
  //       customer_type: addCustomerData.customer_type,
  //       customer_id: addCustomerData.customer_id,
  //       customer_name: addCustomerData.name,
  //       mobile: addCustomerData.mobile,
  //       address: addCustomerData.address,
  //       aadhar_number: addCustomerData.aadhar_number || "",
  //       status: addCustomerData.status,
  //       created_by: "Addsales",
  //       created_date: new Date().toISOString(),
  //     });
  //     closeCustomerModal();
  //   } catch (error) {
  //     console.error("Error adding customer:", error.message);
  //     toast.error("Failed to add customer", 3000, "topRight");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleCustomerSubmit = async (e) => {
    e.preventDefault();

    // Validate form fields
    if (!validateCustomerForm(addCustomerData)) return;

    try {
      setLoading(true);

      // Ensure aadhar_number is a string (not null)
      const formData = {
        ...addCustomerData,
        aadhar_number: addCustomerData.aadhar_number || "", // Fallback to empty string if null/undefined
        created_date: new Date().toISOString().slice(0, 19).replace("T", " "),
        updated_date: new Date().toISOString().slice(0, 19).replace("T", " "),
        created_by_manager: selectedManager,
      created_by_staff: selectedStaff,
      };

      // Send POST request to backend
      await axios.post(`${ApiUrl}/Api/customer.php`, formData);

      // Show success message
      toast.success("Customer added successfully!", {
        duration: 3000,
        position: "topRight",
      });

      // Fetch updated customer data
      await fetchCustomerData();

      // Update relevant state (if needed for other operations)
      setAddData((prevData) => ({
        ...prevData,
        customer_type: addCustomerData.customer_type,
        customer_id: addCustomerData.customer_id,
        customer_name: addCustomerData.name,
        mobile: addCustomerData.mobile,
        address: addCustomerData.address,
        aadhar_number: addCustomerData.aadhar_number ?? "",
        status: addCustomerData.status,
        created_by: "AddLoan",
        created_date: new Date().toISOString(),
      }));

      // Close modal or reset UI
      closeCustomerModal();
    } catch (error) {
      console.error("Error adding customer:", error.message);
      toast.error("Failed to add customer", {
        duration: 3000,
        position: "topRight",
      });
    } finally {
      setLoading(false);
    }
  };

  const toggleProductInputMode = () => {
    setIsManualProductInput(!isManualProductInput);
    if (!isManualProductInput) {
      setNewItem({ ...newItem, product_name: "" });
    }
  };

  const handleLoanSubmit = async () => {
    if (isSubmitting) return;
    setIsSubmitting(true);

    try {
      if (!addData.customer_type) {
        toast.error("Please select a customer type", 3000, "topRight");
        return;
      }
      if (!addData.customer_id) {
        toast.error("Please select a customer", 3000, "topRight");
        return;
      }
      if (addData.loan_list.length === 0) {
        toast.error("Please add at least one item", 3000, "topRight");
        return;
      }
      if (!addData.loan_amount || parseFloat(addData.loan_amount) <= 0) {
        toast.error("Please ensure a valid loan amount", 3000, "topRight");
        return;
      }
      // NEW VALIDATIONS FOR MANAGER AND STAFF
      const role = JSON.parse(localStorage.getItem("user") || "{}").role || "";
const isAdmin = role === "Admin" || role === "admin";

if (!selectedManager) {
  toast.error("Please select a Manager", 3000, "topRight");
  return;
}
if (!isAdmin && !selectedStaff) {
  toast.error("Please select a Staff", 3000, "topRight");
  return;
}

      const formData = {
        loan_id: addData.loan_id,
        loan_date: addData.loan_date,
        customer_id: addData.customer_id,
        customer_type: addData.customer_type,
        loan_amount: addData.loan_amount,
        notes: addData.notes,
        loan_list: addData.loan_list,
        // NEW FIELDS FOR MANAGER AND STAFF
        manager: addData.manager || "",
        manager_name: addData.manager_name || "",
        staff: addData.staff || "",
        created_by: addData.created_by,
        created_date: new Date().toISOString().slice(0, 19).replace("T", " "),
      };

      const response = await axios.post(`${ApiUrl}/Api/loan.php`, formData);

      if (response.data.status) {
        toast.success("Loan added successfully!", 3000, "topRight");
        navigate("/loan");
      } else {
        toast.error(
          response.data.message || "Failed to save loan data",
          3000,
          "topRight",
        );
      }
    } catch (error) {
      console.error("Error creating loan:", error);
      toast.error("Error creating loan. Please try again.", 3000, "topRight");
    } finally {
      setIsSubmitting(false);
    }
  };
  const handleCancel = () => {
    navigate("/loan");
  };

  const filteredProducts = productData.filter(
    (product) => product.category === newItem.category,
  );

  // Filter customers based on selected customer_type
  const filteredCustomers = addData.customer_type
    ? customerData.filter(
        (customer) => customer.customer_type === addData.customer_type,
      )
    : [];

  const fetchLoggedInUser = () => {
    try {
      const userInfo = JSON.parse(localStorage.getItem("user") || "{}");
      if (userInfo && userInfo.user_id) {
        setLoggedInUser(userInfo);
      }
    } catch (error) {
      console.error("Error reading logged-in user:", error);
    }
  };

  // Fetch all users (for manager/staff dropdowns)
  const fetchUserData = async () => {
    try {
      const res = await axios.get(`${ApiUrl}/Api/user.php`);
      const users = Array.isArray(res.data.data) ? res.data.data : [];
      setUserdata(users);
    } catch (err) {
      console.error("Failed to fetch users", err);
      toast.error("Failed to load staff data", 3000, "topRight");
    }
  };

  // Auto-lock Manager & Staff based on logged-in user role
  useEffect(() => {
    if (!loggedInUser || userdata.length === 0) return;

    const currentUser = userdata.find(
      (u) => u.user_id === loggedInUser.user_id,
    );
    if (!currentUser) return;

    if (currentUser.role === "Manager" || currentUser.role === "manager") {
      setSelectedManager(currentUser.id.toString());
      setIsManagerLocked(true);

      // Load staff under this manager
      const staff = userdata.filter(
        (u) =>
          u.manager_id === currentUser.user_id &&
          (u.role === "Employee" || u.role === "employee"),
      );
      setStaffList(staff);

      // Optional: pre-fill in form if you store manager/staff in formData
      setAddData((prev) => ({
        ...prev,
        manager: currentUser.user_id,
        manager_name: currentUser.name,
      }));
    } else if (
      currentUser.role === "Employee" ||
      currentUser.role === "employee"
    ) {
      setSelectedStaff(currentUser.name);
      setIsStaffLocked(true);

      const manager = userdata.find(
        (u) =>
          u.user_id === currentUser.manager_id &&
          (u.role === "Manager" || u.role === "manager"),
      );

      if (manager) {
        setSelectedManager(manager.id.toString());
        setIsManagerLocked(true);

        const staffUnderManager = userdata.filter(
          (u) =>
            u.manager_id === manager.user_id &&
            (u.role === "Employee" || u.role === "employee"),
        );
        setStaffList(staffUnderManager);

        setAddData((prev) => ({
          ...prev,
          manager: manager.user_id,
          manager_name: manager.name,
          staff: currentUser.name,
        }));
      }
    }
    // Admin → do nothing (free choice)
  }, [loggedInUser, userdata]);

  // Handle Manager Change
  const handleManagerChange = (e) => {
    if (isManagerLocked) return;
    const managerId = e.target.value;
    setSelectedManager(managerId);
    setSelectedStaff("");
    setStaffList([]);

    if (managerId) {
      const managerObj = userdata.find((u) => u.id === parseInt(managerId));
      if (managerObj) {
        const staff = userdata.filter(
          (u) =>
            u.manager_id === managerObj.user_id &&
            (u.role === "Employee" || u.role === "employee"),
        );
        setStaffList(staff);

        setAddData((prev) => ({
          ...prev,
          manager: managerObj.user_id,
          manager_name: managerObj.name,
        }));
      }
    } else {
      setAddData((prev) => ({ ...prev, manager: "", manager_name: "" }));
    }
  };

  // Handle Staff Change
  const handleStaffChange = (e) => {
    if (isStaffLocked) return;
    const staffName = e.target.value;
    setSelectedStaff(staffName);
    setAddData((prev) => ({ ...prev, staff: staffName }));
  };

  return (
    <>
      {loading && (
        <div className="loading-overlay">
          <div className="loading-message">
            <div className="loadinggif"></div>
          </div>
        </div>
      )}

      <div className="container-fluid position-relative py-5 mb-4">
        {/* Back Button at Top-Right Corner */}
        <div
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            zIndex: 1000,
          }}
        >
          <button className="btn btn-secondary btn-sm" onClick={handleCancel}>
            <i className="fa-solid fa-arrow-left me-1"></i> Back
          </button>
        </div>
        <div className="row g-3">
          <div className="col-lg-5">
            <div className="card p-2">
              <div className="row g-2">
                <div className="col-md-3">
                  <label className="form-label">Loan ID</label>
                  <input
                    type="text"
                    className="form-control bg-light"
                    value={addData.loan_id || "Select Code, Input & Add Items"}
                    disabled
                    readOnly
                  />
                </div>
                <div className="col-md-3">
                  <label className="form-label">Loan Date</label>
                  <input
                    type="date"
                    className="form-control"
                    name="loan_date"
                    value={addData.loan_date}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="col-lg-3 col-md-3">
                  <div className="mb-3">
                    <label htmlFor="code_update" className="form-label">
                      Code (A-Z)
                    </label>
                    <select
                      className="form-select"
                      id="code_update"
                      value={code}
                      onChange={(e) => setCode(e.target.value)}
                      required
                    >
                      <option value="">Select Code</option>
                      {[...Array(26)].map((_, i) => {
                        const letter = String.fromCharCode(65 + i);
                        return (
                          <option key={letter} value={letter}>
                            {letter}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
                <div className="col-lg-3 col-md-3">
                  <div className="mb-3">
                    <label htmlFor="input_number" className="form-label">
                      Input (1-500)
                    </label>
                    <select
                      className="form-select"
                      id="input_number"
                      value={inputNumber}
                      onChange={(e) => setInputNumber(e.target.value)}
                      required
                    >
                      <option value="">Select Number</option>
                      {[...Array(500)].map((_, i) => (
                        <option key={i + 1} value={i + 1}>
                          {i + 1}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-7">
            <div className="card h-100 p-2">
              <div className="row g-2">
                <div className="col-md-3">
                  <label className="form-label">
                    Customer Type <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-select"
                    name="customer_type"
                    value={addData.customer_type}
                    onChange={handleCustomerTypeChange}
                  >
                    <option value="">Select Type</option>
                    <option value="Walk-In">Walk-In</option>
                    <option value="Retailer">Retailer</option>
                    <option value="Regular">Regular</option>
                  </select>
                </div>
                <div className="col-sm-6 col-md-3">
                  <label className="form-label">
                    Customer <span className="text-danger">*</span>
                  </label>
                  <div className="input-group">
                    <select
                      className="form-select"
                      onChange={handleCustomerChange}
                      value={
                        addData.customer_id
                          ? `${addData.customer_id}-${
                              customerData.find(
                                (c) =>
                                  c.customer_id === addData.customer_id &&
                                  c.name === addData.customer_name,
                              )?.id || ""
                            }`
                          : ""
                      }
                      disabled={!addData.customer_type}
                    >
                      <option value="">Select Customer</option>
                      {Array.isArray(filteredCustomers) &&
                        filteredCustomers.map((item) => (
                          <option
                            key={`${item.customer_id}-${item.id}`}
                            value={`${item.customer_id}-${item.id}`}
                          >
                            {item.customer_id} - {item.name}
                          </option>
                        ))}
                    </select>
                    <div className="btn-group">
                      <button
                        type="button"
                        className="btn btn-outline-dark btn-sm mx-1"
                        onClick={openCustomerModal}
                        disabled={!addData.customer_type}
                      >
                        <i className="bi bi-plus"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div className="col-sm-6 col-md-3">
                  <label className="form-label">Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="customer_name"
                    placeholder="Name"
                    value={addData.customer_name || ""}
                    onChange={handleInputChange}
                    disabled
                  />
                </div>
                <div className="col-sm-6 col-md-3">
                  <label className="form-label">Mobile Number</label>
                  <input
                    type="text"
                    className="form-control"
                    name="mobile"
                    value={addData.mobile || ""}
                    placeholder="Mobile Number"
                    onChange={handleInputChange}
                    disabled
                  />
                </div>
                {/* <div className="col-sm-6 col-md-3">
                  <label className="form-label">Address</label>
                  <input
                    type="text"
                    className="form-control"
                    name="address"
                    placeholder="Address"
                    value={addData.address || ""}
                    onChange={handleInputChange}
                    disabled
                  />
                </div> */}
              </div>
            </div>
          </div>
        </div>

       <div className="row mt-3">
  {(() => {
    const role = JSON.parse(localStorage.getItem("user") || "{}").role || "";
    const isAdmin = role === "Admin" || role === "admin";
    return (
      <>
        <div className="col-md-3">
          <label className="form-label">
            Manager <span className="text-danger">*</span>
          </label>
          <select
            className="form-select"
            value={selectedManager}
            onChange={handleManagerChange}
            disabled={isManagerLocked}
          >
            <option value="">Select Manager</option>
            {userdata
              .filter(u => u.role === "Manager" || u.role === "manager")
              .map(manager => (
                <option key={manager.id} value={manager.id}>
                  {manager.name}
                </option>
              ))}
          </select>
        </div>

        {!isAdmin && (
          <div className="col-md-3">
            <label className="form-label">
              Staff <span className="text-danger">*</span>
            </label>
            <select
              className="form-select"
              value={selectedStaff}
              onChange={handleStaffChange}
              disabled={isStaffLocked || !selectedManager}
            >
              <option value="">Select Staff</option>
              {staffList.map(staff => (
                <option key={staff.id} value={staff.name}>
                  {staff.name}
                </option>
              ))}
            </select>
          </div>
        )}
      </>
    );
  })()}
</div>

        <div className="card card-body mt-2">
          <div className="row">
            <div className="col-md-2">
              <label className="form-label">Select Category</label>
              <select
                className="form-select"
                name="category"
                value={newItem.category}
                onChange={handleItemInputChange}
              >
                <option value="">Select Category</option>
                <option value="Gold">Gold</option>
                <option value="Silver">Silver</option>
              </select>
            </div>
            <div className="col-md-3">
  <label className="form-label">Product Name</label>
  <div className="d-flex align-items-center">
    {isManualProductInput ? (
      <input
        type="text"
        className="form-control me-2"
        name="product_name"
        value={newItem.product_name}
        onChange={handleItemInputChange}
        disabled={!newItem.category}
        placeholder="Enter product name"
      />
    ) : (
      <>
        <select
          className="form-select me-2"
          name="product_name"
          value={newItem.product_name}
          onChange={(e) => {
            const selectedValue = e.target.value;
            const selectedProduct = filteredProducts.find(p => 
              (p.item_name_english || p.item_name) === selectedValue
            );
            setNewItem({
              ...newItem,
              product_name: selectedValue,
              product_name_english: selectedProduct?.item_name_english || selectedProduct?.item_name || selectedValue,
              product_name_tamil: selectedProduct?.item_name_tamil || "",
            });
          }}
          disabled={!newItem.category}
        >
          <option value="">Select Product</option>
          {filteredProducts.map((product) => {
            const displayName = product.item_name_tamil 
              ? `${product.item_name_english || product.item_name} / ${product.item_name_tamil}`
              : (product.item_name_english || product.item_name);
            return (
              <option key={product.id} value={product.item_name_english || product.item_name}>
                {displayName}
              </option>
            );
          })}
        </select>
        <button
          type="button"
          className="btn btn-outline-primary btn-sm me-1"
          onClick={openProductModal}
          title="Add New Product"
          disabled={!newItem.category}
        >
          <i className="bi bi-plus"></i>
        </button>
      </>
    )}
    {/* <button
      type="button"
      className="btn btn-outline-dark btn-sm"
      onClick={toggleProductInputMode}
      title={isManualProductInput ? "Select from list" : "Enter manually"}
    >
      <i className={`bi ${isManualProductInput ? "bi-x" : "bi-plus"}`}></i>
    </button> */}
  </div>
  {!newItem.category && (
    <small className="text-muted text-danger">Please select category first</small>
  )}
</div>

            <div className="col-md-2">
              <label className="form-label">Qty</label>
              <input
                type="text"
                inputMode="numeric"
                className="form-control"
                placeholder="Qty"
                name="quantity"
                value={newItem.quantity}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d*$/.test(value)) {
                    handleItemInputChange(e);
                  }
                }}
              />
            </div>

            <div className="col-md-2">
              <label className="form-label">Weight (g)</label>
              <input
                type="text"
                inputMode="decimal"
                className="form-control"
                placeholder="(g)"
                name="weight"
                value={newItem.weight}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d*\.?\d{0,3}$/.test(value)) {
                    handleItemInputChange(e);
                  }
                }}
              />
            </div>

            <div className="col-md-2">
              <label className="form-label">Amount (₹)</label>
              <input
                type="text"
                inputMode="decimal"
                className="form-control"
                placeholder="Amount"
                name="amount"
                value={newItem.amount}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d*\.?\d*$/.test(value)) {
                    handleItemInputChange(e);
                  }
                }}
              />
            </div>

            <div className="col-md-1">
              <label className="form-label"></label>
              {editingItemId === null ? (
                <button
                  className="btn btn-success btn-sm w-100 mt-4"
                  onClick={handleAddItem}
                >
                  <i className="bi bi-plus"></i>
                </button>
              ) : (
                <button
                  className="btn btn-info btn-sm w-100 mt-4"
                  onClick={handleUpdateItem}
                >
                  <i className="bi bi-check"></i>
                </button>
              )}
            </div>
          </div>
        </div>

        <div className="container-fluid mt-2">
          <div className="row">
            <div className="col-lg-8">
              <div className="row">
                <div className="card card-body">
                  <h6>Item List</h6>
                  <div className="p-3" style={{ backgroundColor: "#E8F0FA" }}>
                    <div className="table-container">
                      <table className="table table-layout-fixed w-100">
                        <thead className="bg-light">
                          <tr>
                            <th>S.No</th>
                            <th>Category</th>
                            <th>Product</th>
                            <th>Qty</th>
                            <th>Weight</th>
                            <th>Amount (₹)</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {addData.loan_list.length > 0 ? (
                            addData.loan_list.map((item, index) => (
                              <tr key={item.id || index}>
                                <td>{index + 1}</td>
                                <td>{item.category}</td>
                                <td>{item.product_name}</td>
                                <td>{item.quantity}</td>
                                <td>{item.weight}</td>
                                <td>{item.amount}</td>
                                <td>
                                  <button
                                    className="btn btn-sm btn-warning me-1"
                                    onClick={() => handleEditItem(item)}
                                  >
                                    <i className="bi bi-pencil"></i>
                                  </button>
                                  <button
                                    className="btn btn-sm btn-danger"
                                    onClick={() => handleRemoveItem(item.id)}
                                  >
                                    <i className="bi bi-trash"></i>
                                  </button>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="7" className="text-center">
                                No items added yet
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="card card-body">
                <div className="row mb-2">
                  <div className="col-md-6">
                    <label className="form-label">Loan Amount (₹)</label>
                  </div>
                  <div className="col-md-6">
                    <input
                      type="text"
                      className="form-control"
                      name="loan_amount"
                      value={addData.loan_amount}
                      readOnly
                    />
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-6">
                    <label className="form-label">Notes</label>
                  </div>
                  <div className="col-md-6">
                    <input
                      type="text"
                      className="form-control"
                      name="notes"
                      value={addData.notes}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="col-lg-12">
                    <button
                      className="btn btn-sm btn-success w-100"
                      onClick={handleLoanSubmit}
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? "Submitting..." : "Submit"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div
        className={`modal fade ${showModal ? "show" : ""}`}
        style={{ display: showModal ? "block" : "none" }}
        tabIndex="-1"
        aria-labelledby="printModalLabel"
        aria-hidden={!showModal}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h6 className="modal-title text-primary" id="printModalLabel">
                Print (If You Want Print or Not?)
              </h6>
              <button
                type="button"
                className="btn-close"
                style={{ fontSize: "10px" }}
                onClick={closeModal}
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <form>
                <div className="text-center">
                  <img
                    alt=""
                    className="border"
                    src={require("../../assets/images/Print_Demo.png")}
                    style={{ height: "300px" }}
                  ></img>
                </div>
                <div className="d-flex justify-content-center mt-4">
                  <button
                    type="button"
                    className="btn btn-secondary btn-sm mx-2"
                    onClick={() => navigate("/loan")}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary btn-sm"
                    onClick={handlePrint}
                  >
                    Print
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div> */}

      <div
        className={`modal fade ${showCustomerModal ? "show" : ""}`}
        style={{
          display: showCustomerModal ? "block" : "none",
          backgroundColor: "rgba(0,0,0,0.5)",
        }}
        tabIndex="-1"
        aria-labelledby="addCustomerModalLabel"
        aria-hidden={!showCustomerModal}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h6
                className="modal-title text-primary"
                id="addCustomerModalLabel"
              >
                Add Customer
              </h6>
              <button
                type="button"
                className="btn-close"
                style={{ fontSize: "10px" }}
                onClick={closeCustomerModal}
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleCustomerSubmit}>
                <div className="row">
                  <div className="col-lg-6">
                    <div className="mb-3">
                      <label htmlFor="customerType" className="form-label">
                        Customer Type <span className="text-danger">*</span>
                      </label>
                      <select
                        className={`form-control ${
                          validationErrors.customer_type ? "is-invalid" : ""
                        }`}
                        id="customerType"
                        value={addCustomerData.customer_type}
                        onChange={(e) => {
                          const customerType = e.target.value;
                          setAddCustomerData({
                            ...addCustomerData,
                            customer_type: customerType,
                          });
                          generateCustomerId(customerType);
                        }}
                        required
                        disabled={addData.customer_type}
                      >
                        <option value="" disabled>
                          Select Customer Type
                        </option>
                        <option value="Walk-In">Walk-In</option>
                        <option value="Regular">Regular</option>
                        <option value="Retailer">Retailer</option>
                      </select>
                      {validationErrors.customer_type && (
                        <div className="invalid-feedback">
                          {validationErrors.customer_type}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="mb-3">
                      <label htmlFor="customerId" className="form-label">
                        Customer ID
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="customerId"
                        placeholder="Customer ID will be generated"
                        value={addCustomerData.customer_id}
                        disabled
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-6">
                    <div className="mb-3">
                      <label htmlFor="name" className="form-label">
                        Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control ${
                          validationErrors.name ? "is-invalid" : ""
                        }`}
                        id="name"
                        placeholder="Enter Name"
                        value={addCustomerData.name}
                        onChange={(e) =>
                          setAddCustomerData({
                            ...addCustomerData,
                            name: e.target.value,
                          })
                        }
                        required
                      />
                      {validationErrors.name && (
                        <div className="invalid-feedback">
                          {validationErrors.name}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="mb-3">
                      <label htmlFor="mobile" className="form-label">
                        Mobile Number <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        maxLength="10"
                        className={`form-control ${
                          validationErrors.mobile ? "is-invalid" : ""
                        }`}
                        id="mobile"
                        placeholder="Enter Mobile"
                        value={addCustomerData.mobile}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^\d{0,10}$/.test(value)) {
                            setAddCustomerData({
                              ...addCustomerData,
                              mobile: value,
                            });
                          }
                        }}
                        required
                      />
                      {validationErrors.mobile && (
                        <div className="invalid-feedback">
                          {validationErrors.mobile}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="mb-3">
                  <label htmlFor="address" className="form-label">
                    Address
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="address"
                    placeholder="Enter Address"
                    value={addCustomerData.address}
                    onChange={(e) =>
                      setAddCustomerData({
                        ...addCustomerData,
                        address: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="customerStatus" className="form-label">
                    Status <span className="text-danger">*</span>
                  </label>
                  <select
                    className={`form-select ${
                      validationErrors.status ? "is-invalid" : ""
                    }`}
                    id="status"
                    value={addCustomerData.status}
                    onChange={(e) =>
                      setAddCustomerData({
                        ...addCustomerData,
                        status: e.target.value,
                      })
                    }
                    required
                  >
                    <option value="" disabled>
                      Select Status
                    </option>
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                  </select>
                  {validationErrors.status && (
                    <div className="invalid-feedback">
                      {validationErrors.status}
                    </div>
                  )}
                </div>

                <div className="text-center mt-4">
                  <button
                    type="submit"
                    className="btn btn-primary btn-sm px-4"
                    disabled={loading}
                  >
                    {loading ? "Submitting..." : "Submit"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Add Product Modal */}
<div
  className={`modal fade ${showProductModal ? "show" : ""}`}
  style={{
    display: showProductModal ? "block" : "none",
    backgroundColor: "rgba(0,0,0,0.5)",
  }}
  tabIndex="-1"
  aria-labelledby="addProductModalLabel"
  aria-hidden={!showProductModal}
>
  <div className="modal-dialog modal-dialog-centered">
    <div className="modal-content">
      <div className="modal-header">
        <h6 className="modal-title text-primary" id="addProductModalLabel">
          Add Product
        </h6>
        <button
          type="button"
          className="btn-close"
          style={{ fontSize: "10px" }}
          onClick={closeProductModal}
          aria-label="Close"
        ></button>
      </div>
      <div className="modal-body">
        <form onSubmit={handleProductSubmit}>
          <div className="row">
            <div className="col-lg-6">
              <div className="mb-3">
                <label htmlFor="item_code" className="form-label">
                  Item Code
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="item_code"
                  value={productAddData.item_code}
                  disabled
                  readOnly
                />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="mb-3">
                <label htmlFor="product_category" className="form-label">
                  Category <span className="text-danger">*</span>
                </label>
                <select
                  className={`form-select ${productFormErrors.category ? "is-invalid" : ""}`}
                  id="product_category"
                  value={productAddData.category}
                  onChange={(e) =>
                    setProductAddData({ ...productAddData, category: e.target.value })
                  }
                >
                  <option value="">Select Category</option>
                  <option value="Gold">Gold</option>
                  <option value="Silver">Silver</option>
                </select>
                {productFormErrors.category && (
                  <div className="invalid-feedback">{productFormErrors.category}</div>
                )}
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-12">
              <div className="mb-3">
                <label htmlFor="item_name_english" className="form-label">
                  Item Name <span className="text-danger">*</span>
                </label>
                <div className="input-group">
                  <input
                    type="text"
                    className={`form-control ${productFormErrors.item_name ? "is-invalid" : ""}`}
                    id="item_name_english"
                    placeholder="Enter item name in English (Tamil will auto-translate)"
                    value={productAddData.item_name_english}
                    onChange={(e) =>
                      setProductAddData({
                        ...productAddData,
                        item_name_english: e.target.value,
                        item_name: e.target.value,
                        item_name_tamil: "",
                      })
                    }
                    onBlur={async (e) => {
                      const val = e.target.value.trim();
                      if (val && !productAddData.item_name_tamil) {
                        const tamil = await translateToTamil(val);
                        if (tamil) {
                          setProductAddData(prev => ({ ...prev, item_name_tamil: tamil }));
                          toast.info(`Tamil translation: ${tamil}`, 2000, "topRight");
                        }
                      }
                    }}
                  />
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    title="Translate to Tamil"
                    disabled={isTranslating || !productAddData.item_name_english}
                    style={{height:"35px"}}
                    onClick={async () => {
                      const tamil = await translateToTamil(productAddData.item_name_english);
                      if (tamil) {
                        setProductAddData(prev => ({ ...prev, item_name_tamil: tamil }));
                        toast.success("Translated successfully!", 1500, "topRight");
                      } else {
                        toast.error("Translation failed. Please try again.", 2000, "topRight");
                      }
                    }}
                  >
                    {isTranslating ? (
                      <span className="spinner-border spinner-border-sm" />
                    ) : (
                      "🌐 Translate"
                    )}
                  </button>
                </div>
                {productAddData.item_name_tamil && (
                  <small className="text-muted mt-1 d-block">
                    <strong>Tamil:</strong> {productAddData.item_name_tamil}
                    <button
                      type="button"
                      className="btn btn-link btn-sm p-0 ms-2 text-muted"
                      onClick={() => setProductAddData(prev => ({ ...prev, item_name_tamil: "" }))}
                    >
                      ✕ clear
                    </button>
                  </small>
                )}
                {productFormErrors.item_name && (
                  <div className="invalid-feedback">{productFormErrors.item_name}</div>
                )}
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-6">
              <div className="mb-3">
                <label htmlFor="pure_percent" className="form-label">
                  Purity (%) <span className="text-danger">*</span>
                </label>
                <input
                  type="number"
                  step="0.1"
                  min="0"
                  max="100"
                  className={`form-control ${productFormErrors.pure_percent ? "is-invalid" : ""}`}
                  id="pure_percent"
                  placeholder="e.g. 99.9"
                  value={productAddData.pure_percent}
                  onChange={(e) =>
                    setProductAddData({ ...productAddData, pure_percent: e.target.value })
                  }
                />
                {productFormErrors.pure_percent && (
                  <div className="invalid-feedback">{productFormErrors.pure_percent}</div>
                )}
              </div>
            </div>
            <div className="col-lg-6">
              <div className="mb-3">
                <label htmlFor="product_status" className="form-label">
                  Status <span className="text-danger">*</span>
                </label>
                <select
                  className={`form-select ${productFormErrors.status ? "is-invalid" : ""}`}
                  id="product_status"
                  value={productAddData.status}
                  onChange={(e) =>
                    setProductAddData({ ...productAddData, status: e.target.value })
                  }
                >
                  <option value="">Select Status</option>
                  <option value="Active">Active</option>
                  <option value="Inactive">Inactive</option>
                </select>
                {productFormErrors.status && (
                  <div className="invalid-feedback">{productFormErrors.status}</div>
                )}
              </div>
            </div>
          </div>

          <div className="row">
            <div className="mb-3">
              <label htmlFor="product_image" className="form-label">
                Image Upload
              </label>
              <input
                type="file"
                className="form-control"
                id="product_image"
                onChange={(e) =>
                  setProductAddData({ ...productAddData, image: e.target.files[0] })
                }
                accept="image/*"
              />
            </div>
          </div>

          <div className="text-center mt-4">
            <button
              type="submit"
              className="btn btn-primary btn-sm px-4"
              disabled={loading}
            >
              {loading ? "Adding..." : "Add Product"}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

{(showModal || showCustomerModal || showProductModal) && (
  <div className="modal-backdrop fade show"></div>
)}
    </>
  );
}

export default AddLoan;
